export type {LoaderWithParser} from '@ptloader/loader-utils';
